import request from './request'
import { AccountantConnection } from '../../types'

export default class ConnectionsController {
  static getConnections(): Promise<AccountantConnection[]> {
    return request('/api/connections')
  }

  static requestAccess(email: string): Promise<{ success: boolean }> {
    return request('/api/connections', { method: 'POST', body: { email } })
  }

  static accept(id: string): Promise<AccountantConnection> {
    return request(`/api/connections/${id}/accept`, { method: 'POST' })
  }

  static remove(id: string): Promise<{ success: boolean }> {
    return request(`/api/connections/${id}`, { method: 'DELETE' })
  }
}
